module.exports = __webpack_public_path__ + "static/media/under_construction2.163905c5.png";